
import { Component, Prop, Vue } from 'vue-property-decorator'
import CSSCheckIcon from '~/components/common/CSSCheckIcon.vue'
import Icon from '~/components/common/icon/Icon.vue'

@Component({
  name: 'ChoiceIcon',
  components: {
    CSSCheckIcon,
    Icon
  }
})
export default class ChoiceIcon extends Vue {
  @Prop({ type: String, default: 'span' }) tag!: string
  @Prop({ type: Number, default: 22 }) size!: number
  @Prop({ type: Boolean, default: false }) marked!: boolean
  @Prop({ type: String, default: '5px' }) borderRadius!:string
  @Prop({ type: Boolean, default: false }) disabled!: boolean
  // @ts-ignore
  @Prop({ type: String, default: 'check', validator: val => val.match(/check|cross/) }) type!: 'check' | 'cross'

  get currentStyles() {
    if (this.disabled) {
      return {
        'background-color': this.$tokens.color_alabaster,
        'border-color': this.$tokens.color_geyser
      }
    }

    return {
      'border-color': this.marked
        ? this.type === 'check'
          ? this.$tokens.color_turquoise
          : this.$tokens.color_carnation
        : this.$tokens.color_geyser,
      'background-color': this.marked
        ? this.type === 'check'
          ? this.$tokens.color_turquoise
          : this.$tokens.color_carnation
        : this.$tokens.color_white
    }
  }

  private px(num: number) {
    return num + 'px'
  }
}
